<div class="fixed inset-0 z-[10000] flex items-center justify-center p-4 no-print" role="dialog" aria-modal="true" aria-labelledby="cancel-title">
  <div class="absolute inset-0 bg-dark-text/60 backdrop-blur-sm" (click)="close()"></div>
  <div cntFocusTrap (escape)="close()" class="relative bg-white rounded-2xl shadow-[0_24px_48px_rgba(0,0,0,0.2)] max-w-md w-full p-6 md:p-8 max-h-[90dvh] overflow-y-auto">
    <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-trinidad/10 mb-4">
      <span aria-hidden="true" class="material-symbols-outlined text-3xl text-trinidad">cancel</span>
    </div>
    <h2 id="cancel-title" class="font-headline font-bold text-dark-text text-2xl tracking-tight mb-2">
      {{ isRequest ? 'Cancel this request?' : 'Cancel this booking?' }}
    </h2>

    <!-- Refund preview — same rules the server applies on cancel. -->
    <div class="mb-4 p-3 rounded-lg flex items-start gap-3"
      [ngClass]="preview.kind === 'none' || preview.kind === 'partial' ? 'bg-gold/15 border border-gold/40' : 'bg-jungle-green/10 border border-jungle-green/30'"
      [style.color]="preview.kind === 'none' || preview.kind === 'partial' ? '#8a5a00' : '#1f4933'">
      <span aria-hidden="true" class="material-symbols-outlined text-base mt-0.5" style="font-variation-settings: 'FILL' 1;">
        {{ preview.kind === 'none' || preview.kind === 'partial' ? 'warning' : 'check_circle' }}
      </span>
      <div class="flex-1 text-xs font-body leading-relaxed">
        @switch (preview.kind) {
          @case ('request') {
            <strong>The host hasn't accepted yet</strong>, so cancelling simply withdraws your request.
          }
          @case ('refund') {
            <strong>{{ asHost ? 'Your guest gets' : 'You get' }} {{ preview.amount | currency: 'USD' : 'symbol' : '1.2-2' }} back</strong>
            as CurbNTurf Cash — not a credit to {{ asHost ? 'their' : 'your' }} card.
          }
          @case ('partial') {
            <strong>{{ POLICY_LABEL[preview.policy] }} policy: {{ asHost ? 'your guest gets' : 'you get' }} 50% back —
            {{ preview.amount | currency: 'USD' : 'symbol' : '1.2-2' }}</strong> as CurbNTurf Cash.
          }
          @case ('none') {
            @if (preview.policy === 'exclusive') {
              <strong>{{ POLICY_LABEL[preview.policy] }} policy: no refund.</strong>
            } @else {
              <strong>No refund</strong> — the refund window under the {{ POLICY_LABEL[preview.policy] }} policy closed
              {{ preview.refundDeadline | date: 'MMM d' }}.
            }
          }
        }
        @if (preview.kind === 'refund' || preview.kind === 'partial') {
          <span class="block mt-1 opacity-80">Refund window closes {{ preview.refundDeadline | date: 'MMM d, h:mm a' }}.</span>
        }
      </div>
    </div>

    @if (booking.changeRequested) {
      <p class="text-xs text-muted-text font-body leading-relaxed mb-4">The change you requested is withdrawn too.</p>
    }
    <p class="text-sm text-muted-text font-body leading-relaxed mb-5">
      {{ asHost ? 'Your guest will be notified.' : 'The host will be notified.' }}
    </p>

    <label class="flex flex-col gap-2 mb-6">
      <span class="text-xs font-label uppercase tracking-[0.1em] text-muted-text font-bold">Reason <span class="text-muted-text/70 normal-case font-normal">(optional, shared with {{ asHost ? 'your guest' : 'the host' }})</span></span>
      <textarea [(ngModel)]="reason" name="cancelReason" rows="3" maxlength="240"
        placeholder="Change of plans, weather, …"
        class="bg-cream/60 border border-dark-text/15 rounded-md px-4 py-3 text-sm font-body text-dark-text focus:outline-none focus:border-jungle-green focus:ring-2 focus:ring-jungle-green/15 transition-all resize-none"></textarea>
      <span class="text-[0.6rem] text-muted-text/70 font-body text-right">{{ reason.length }}/240</span>
    </label>
    <div class="flex flex-col-reverse sm:flex-row gap-3 justify-end">
      <button type="button" (click)="close()" [disabled]="cancelling"
        class="px-5 py-2.5 rounded-full bg-white border border-dark-text/15 text-dark-text text-xs uppercase tracking-[0.12em] font-button font-bold hover:border-dark-text disabled:opacity-50">
        {{ isRequest ? 'Keep request' : 'Keep booking' }}
      </button>
      <button type="button" (click)="confirm()" [disabled]="cancelling"
        class="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-trinidad text-white text-xs uppercase tracking-[0.12em] font-button font-bold hover:opacity-95 disabled:opacity-50">
        @if (cancelling) {
          <span aria-hidden="true" class="material-symbols-outlined text-base animate-spin">progress_activity</span>
          Cancelling…
        } @else {
          {{ isRequest ? 'Cancel request' : 'Cancel booking' }}
        }
      </button>
    </div>
  </div>
</div>
